export default "__VITE_ASSET__BDfgEtbL__";